import "typeface-ibm-plex-sans";
import "typeface-libre-baskerville";
import "typeface-montserrat";
import "typeface-open-sans";
import "@fontsource/quicksand";
import "@fontsource/work-sans";

export const theme = {
  // Colors
  background: "#fff",
  textColor: "#333",
  codeColor: "#00263E",
  linkColor: "#04bb00",

  // Used in PageHeader
  pageHeadingBackground: "#fff",
  pageHeadingTextColor: "#333",

  // NavigationBar background color, but also sometimes used as a foreground
  // or border color.
  lightColor: "#D6D6D6",

  // Used for navigation bar
  navBarBackground: "#F2F2F2",
  navBarTextColor: "#303030",

  // Used in ResponsiveTabs (tab text), Download specimen (title text).
  // Typography: headings.
  brandColor: "#303030",

  sidebarColor: "#FCFCFC",
  sidebarColorActive: "#04bb00",
  sidebarColorText: "#303030",
  sidebarColorTextActive: "#04bb00",
  sidebarColorLine: "#EBEBEB",
  sidebarColorHeading: "#303030",

  // Fonts
  fontHeading: "'IBM Plex Sans', sans-serif",
  fontFamily: "'IBM Plex Sans', sans-serif",
};



// WEBPACK FOOTER //
// ./catalog/theme.js